import isFunction from 'lodash/fp/isFunction';

const callAction = (actions: (((...arg: any[]) => any) | undefined)[]) => () =>
  actions.forEach(action => isFunction(action) && action());

export default callAction;
